import { render } from "./recaptcha-submit-button.vue?vue&type=template&id=ca0cfbc8"
import script from "./recaptcha-submit-button.vue?vue&type=script&lang=js"
export * from "./recaptcha-submit-button.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__